var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 6.5,
    stroke: "#F93737"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0001 9.93307C7.10618 9.93307 7.20793 9.89093 7.28294 9.81592C7.35795 9.7409 7.4001 9.63916 7.4001 9.53307C7.4001 9.42699 7.35795 9.32524 7.28294 9.25023C7.20793 9.17522 7.10618 9.13307 7.0001 9.13307C6.89401 9.13307 6.79227 9.17522 6.71726 9.25023C6.64224 9.32524 6.6001 9.42699 6.6001 9.53307C6.6001 9.63916 6.64224 9.7409 6.71726 9.81592C6.79227 9.89093 6.89401 9.93307 7.0001 9.93307Z",
    fill: "#F93737"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6001 8.06641V4.06641H7.4001V8.06641H6.6001Z",
    fill: "#F93737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusRed);
export default __webpack_public_path__ + "static/media/status-red.287e31f1d422d0e75126206fe047643c.svg";
export { ForwardRef as ReactComponent };